module.exports = "/_next/static/images/Protocols@2x-3feac73c90710e56df9bc353b46c45a6.png";